// Types dupliqués depuis gde-admin (repos séparés, comme le reste des « galleryShape »
// de ce dossier) : `FormField` / `ReservationFormConfig` sont la copie site du contrat
// exposé par `GET /api/public/reservation-form`. Toute évolution du contrat côté CRM
// doit être reportée ici à la main.

export interface FormField {
  id: string
  label: string
  type: 'text' | 'email' | 'tel' | 'number' | 'textarea' | 'select' | 'formule'
  required: boolean
  options?: string[]
}

export interface ReservationFormConfig {
  recipient: string
  intro?: string
  submitLabel: string
  successMessage: string
  fields: FormField[]
  /** Lien (billetterie) où envoyer le visiteur après une demande réussie. */
  redirectionUrl?: string
}

/**
 * Le CRM ne publie que des liens http(s) validés ; on revérifie quand même
 * avant d'en faire une navigation — le site ne fait pas confiance au réseau.
 */
export function lienDeRedirection(config: ReservationFormConfig | null | undefined): string | null {
  const brut = config?.redirectionUrl
  if (typeof brut !== 'string' || brut.trim() === '') return null
  try {
    const url = new URL(brut.trim())
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.toString() : null
  } catch {
    return null
  }
}

export const ADMIN_API = (process.env.NEXT_PUBLIC_ADMIN_API_URL || 'https://admin.example.com').replace(/\/$/, '')

/**
 * Récupère la config du formulaire de réservation publiée au CRM.
 *
 * Ne lève jamais : une panne réseau, un CRM injoignable ou une réponse
 * inattendue renvoient `null`. C'est au consommateur (la modale) d'afficher
 * un repli gracieux — la page Formules ne doit jamais casser pour ça.
 */
export async function getReservationForm(): Promise<ReservationFormConfig | null> {
  try {
    const res = await fetch(`${ADMIN_API}/api/public/reservation-form`, { cache: 'no-store' })
    if (!res.ok) return null
    const data = await res.json()
    const config = data?.config
    if (!config || typeof config !== 'object' || !Array.isArray(config.fields)) return null
    return config as ReservationFormConfig
  } catch {
    return null
  }
}
